<script setup>
import { useScheduleFilterMobileState } from '@/schedule/composables/useScheduleFilterMobileState'

const show = useScheduleFilterMobileState()
function toggle() {
  show.value = !show.value
}
const { t } = useI18n()
</script>

<template>
  <DSButton
    class="btn-md h-fit flex-row items-center justify-center flex-gap-2 uppercase md:w-fit lt-lg:flex lg:hidden btn-outline-secondary"
    @click="toggle"
  >
    <DSIcon
      icon="i-far-filter-list"
      size="24"
    />
    {{ t('Filter') }}
  </DSButton>
</template>

<i18n>
{
  "en-us": {
    "Filter": "Filter"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Filter": "Filter"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Filter": "Filtrer"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Filter": "Filtrar"
}
</i18n>
